import { CreateStoreDto } from "../entities/dto/store.dto";
import { Store } from "../entities/interfaces/stores";
import Api, { ApiResponse } from "../utils/axios";

export const list = async (): Promise<ApiResponse<Store[]>> => {
  return await Api.get("/stores");
};

export const create = async (
  createStoreDto: CreateStoreDto
): Promise<ApiResponse<Store[]>> => {
  return await Api.post("/stores", createStoreDto);
};

export const update = async (
  id: string,
  updateStoreDto: CreateStoreDto
): Promise<ApiResponse<Store[]>> => {
  return await Api.patch(`/stores/${id}`, updateStoreDto);
};

const StoreService = { list, create, update };
export default StoreService;
